import * as React from 'react';
import questions from './questions.json';
import QuestionTemplate from './QuestionTemplate';

export default function Emotional() {
  return (
    <div className="question-container">
      {Object.entries(questions.emotional).map(([key, value], index) => (
        <QuestionTemplate
          key={key}
          identifier={key}
          type={value.type}
          label={value.label}
          event={'emotional'}
        />
      ))}
    </div>
  );
}
